import { emitter } from '@/utils/emitter'

export default {
  install (Vue, options) {
    Vue.prototype.$hub = emitter
  }
}
